export class FetchSSE {
  constructor() {
    this.controller = null;
  }

  async connect(url, data, callbacks) {
    // 中止现有连接
    this.disconnect();
    
    this.controller = new AbortController();
    
    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'text/event-stream'
        },
        body: JSON.stringify(data),
        signal: this.controller.signal
      });
      if (response.status != 200) {
        callbacks.onError && callbacks.onError();
        throw new Error(`SSE连接失败: ${response.status}`);
      }

      const reader = response.body.getReader();
      const decoder = new TextDecoder();
      let buffer = '';

      const processChunk = async ({ done, value }) => {
        if (done) {
          callbacks.onComplete && callbacks.onComplete();
          return;
        }

        buffer += decoder.decode(value, { stream: true });
        // 处理SSE格式的消息
        const parts = buffer.split('\n\n');
        buffer = parts.pop();
        
        parts.forEach(part => {
          // const event = { data: '', type: 'message' };
          // part.split('\n').forEach(line => {
          //   const [key, value] = line.split(': ');
          //   if (key === 'data') event.data = value;
          //   else if (key === 'event') event.type = value;
          //   else if (key === 'id') event.lastEventId = value;
          // });
          
          try {
            const parsedData = part;
            // const parsedData = event.data ? JSON.parse(event.data) :'';
            callbacks.onMessage && callbacks.onMessage(parsedData);
          } catch (e) {
            console.error('SSE消息解析错误:', e);
          }
        });

        return reader.read().then(processChunk);
      };

      await reader.read().then(processChunk);
    } catch (err) {
      callbacks.onError && callbacks.onError(err);
    }
  }

  disconnect() {
    if (this.controller) {
      this.controller.abort();
      this.controller = null;
    }
  }
}

export const fetchSSE = new FetchSSE();